import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './css/index.css';
import App from './js/App';
import reportWebVitals from './reportWebVitals';
import * as ReactDOM from 'react-dom/client';

let root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(
	<BrowserRouter basename='/'>
		<App />
	</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
